import { toast } from 'react-toastify';
import { whitelisted_paths, base_url } from '../utils/constants';


let access_token = localStorage.getItem("access_token");

  const signup = async (data) => {
    try {
      const response = await fetch(base_url+"/auth/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message;
        return toast.error(errorMessage);        
      }
  
      const result = await response.json();
      console.log(result);
      // window.location.href = `/verifyemail?user_id=${result.user_id}`;
      window.location.href = `/login`;
      return result;
    } catch (error) {
      toast.error(error.message)
    }
  };

  const login = async (data) => {
    try {
      const response = await fetch(base_url+"/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      });
  
      if (!response.ok) {
        if(response.status == 403){
          const errorResponse = await response.json();
          const errorMessage = errorResponse.message;
          toast.error(errorMessage);        
          return window.location.href = `/verifyemail?user_id=${errorResponse.user_id}`;
        }
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message;
        return toast.error(errorMessage);        
      }
  
      const result = await response.json();
      let {access_token} = result;
      localStorage.setItem("access_token", access_token);
      window.location.href = `/accounts`;
      return result;
    } catch (error) {
      toast.error(error.message)
    }
  };


 const verifyemail = async (data) => {
    try {
      const response = await fetch(base_url+"/auth/verifyemail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message;
        return toast.error(errorMessage);        
      }
  
      const result = await response.json();
      console.log(result);
      let {access_token} = result;
      localStorage.setItem("access_token", access_token);
      window.location.href = `/accounts`;
      return result;
    } catch (error) {
      toast.error(error.message)
    }
  };



  const resendemail = async (data) => {
    try {
      const response = await fetch(base_url+"/auth/resendemail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message;
        return toast.error(errorMessage);        
      }
  
      const result = await response.json();
      return toast.success("Verification code sent")
    } catch (error) {
      toast.error(error.message)
    }
  };


  const get_user_detail = async () => {
    try {
      const response = await fetch(base_url+"/user", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          access_token
        },
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }

      
      const result = await response.json();
      localStorage.setItem("user_detail", JSON.stringify(result));
      return result
    } catch (error) {
      toast.error(error.message)
      return null
    }
  }
  

  const new_account = async (data) => {
    try {
      const response = await fetch(base_url+"/account", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          access_token
        },
        body: data,
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        console.log(errorResponse)
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }
  
      const result = await response.json();
      const {payment_link} = result

      if(payment_link){
        window.open(payment_link, '_blank');
      }else{
        toast.success("Account created")
        window.location.href = `/accounts`;
      }
      return result
    } catch (error) {
      toast.error(error.message)
    }
  }


  const get_account = async (account_id)=>{
    let user_detail = localStorage.getItem("user_detail");
    user_detail = JSON.parse(user_detail);
    let {api_key} = user_detail;
    try {
      const response = await fetch(base_url+`/api/${account_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          api_key
        },
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        console.log(errorResponse)
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }
      const result = await response.json();
      return result
    } catch (error) {
      toast.error(error.message)
      return null
    }
  }

  const get_screen = async (account_id)=>{
    let user_detail = localStorage.getItem("user_detail");
    user_detail = JSON.parse(user_detail);
    let {api_key} = user_detail;
    try {
      const response = await fetch(base_url+`/api/${account_id}/screen`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          api_key
        },
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        console.log(errorResponse)
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }
      const result = await response.json()
      console.log(result)
      return `${result.url}?t=${result.timestamp}`
    } catch (error) {
      return null
    }
  }

  const rescan_qr = async (account_id)=>{
    let user_detail = localStorage.getItem("user_detail");
    user_detail = JSON.parse(user_detail);
    let {api_key} = user_detail;
    try {
      const response = await fetch(base_url+`/api/${account_id}/rescan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          api_key
        },
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        console.log(errorResponse)
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }

      toast.success("QR code rescaned")
    } catch (error) {
      toast.error(error.message)
      return null
    }
  }


  const update_config = async (account_id, data)=>{
    let user_detail = localStorage.getItem("user_detail");
    user_detail = JSON.parse(user_detail);
    let {api_key} = user_detail;
    try {
      const response = await fetch(base_url+`/api/${account_id}/config`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          api_key
        },
        body: data
      });
  
      if (!response.ok) {
        const errorResponse = await response.json();
        console.log(errorResponse)
        const errorMessage = errorResponse.message;
        toast.error(errorMessage);      
        return null  
      }

      toast.success("Upddate successful")
    } catch (error) {
      toast.error(error.message)
    }
  }

  
export {
  verifyemail,
  resendemail,
  signup,
  login,
  get_user_detail,
  new_account,
  get_account,
  get_screen,
  rescan_qr,
  update_config
}
